/**
 * PatrolFlow - GPS Security Management System
 * Copyright © 2025 Tom Hough, PatrolFlow. All rights reserved.
 * 
 * CONFIDENTIAL AND PROPRIETARY
 * 
 * This source code is the exclusive property of Tom Hough and PatrolFlow.
 * Unauthorized copying, modification, distribution, or use of this software,
 * via any medium, is strictly prohibited without explicit written permission
 * from the copyright holder.
 * 
 * For licensing inquiries: tom@patrolflow.ke
 * 
 * @author Tom Hough
 * @company PatrolFlow
 * @website https://patrolflow.ke
 */

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
